export const START_TIME = 'startTime';
export const END_TIME = 'endTime';

// 9:00 AM
export const DEFAULT_START_TIME = '9';

// 17:00 PM
export const DEFAULT_END_TIME = '17';

export const TIME_OPTIONS = [...Array.from({ length: 24 })].map((_, hour) => {
  const period = hour < 12 ? 'AM' : 'PM';
  const displayHour = hour % 12 === 0 ? 12 : hour % 12;

  return {
    label: `${displayHour.toString().padStart(2, '0')}:00 ${period}`,
    value: hour.toString(),
  };
});

// Get available time options based on the selected time
export function getAvailableTimeOptions(key: string, selected: string) {
  const selectedTime = Number.parseInt(selected, 10);

  if (Number.isNaN(selectedTime)) {
    return TIME_OPTIONS;
  }

  return TIME_OPTIONS.filter(({ value }) => {
    const valueOption = Number.parseInt(value, 10);

    return key === START_TIME
      ? valueOption < selectedTime
      : valueOption > selectedTime;
  });
}
